<spark-footer [config]="FOOTER_CONFIG"></spark-footer>
